import Echo from './echo'
import * as type from './constants'

export default function laravelEchoMiddlewareDispatcher() {
    return store => next => action => {
        switch (action.type) {
            case (type.SOCKET_MANAGEMENT_INIT_CONNECT):
                Echo.connect(action.user, store);
                return next(action);
            default:
                return next(action);
        }
    };
}
